import { render, staticRenderFns } from "./ReviewExam.vue?vue&type=template&id=98fbfd42&scoped=true&"
import script from "./ReviewExam.vue?vue&type=script&lang=js&"
export * from "./ReviewExam.vue?vue&type=script&lang=js&"
import style0 from "./ReviewExam.vue?vue&type=style&index=0&id=98fbfd42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98fbfd42",
  null
  
)

export default component.exports